import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { createRef } from 'react';
import CopyToClipboardButton from './CopyToClipboardButton.js';
export default function Discovery({ caseInfo, fileNamesToFilePropertiesMap, displayedDocument, setDisplayedDocument, setSnackBarMessage }) {
    const tableRef = createRef();
    var documentNamesToDisplay = caseInfo !== null && 'documents' in caseInfo ?
        Object.keys(caseInfo['documents']).filter(filename => fileNamesToFilePropertiesMap[filename]['selected']) :
        [];
    var discoveryItems = documentNamesToDisplay.map(documentName => {
        caseInfo['documents'][documentName]['analysis']?.['discovery']?.forEach((discoveryItem, i) => {
            discoveryItem['id'] = documentName + i; // Used in UI as keys for use by React framework
            discoveryItem['source_filename'] = documentName; // File used by SourceDocumentViewer
        });
        return caseInfo['documents'][documentName]['analysis']?.['discovery'];
    })
        .filter(discoveryArr => discoveryArr) // the ?. above can cause null entries; filter them
        .reduce((accumulator, discoveryArr) => accumulator.concat(discoveryArr), [])
        .filter(discoveryItem => isValidDiscoveryItem(discoveryItem));

    if (discoveryItems.length === 0) {
        return (<Typography fontSize="1.2em" fontWeight={200} sx={{ marginTop: "100px", marginBottom: "500px" }}>
            Potential evidence will be automatically extracted from uploaded Discovery documents such as Depositions, Interrogatories and displayed here.
        </Typography>)
    }

    var tableBodyRows = discoveryItems
        .map(discoveryItem => (
            <TableRow
                key={discoveryItem['id']}
                onClick={() => {
                    setDisplayedDocument({ 'name': discoveryItem['source_filename'], 'page': discoveryItem['page'] })
                }}
                className={discoveryItem['source_filename'] === displayedDocument?.['name'] ? "selected" : ""} >
                <TableCell>
                    <Typography component='div' fontWeight={200}>
                        "{discoveryItem.before_verbatim}
                        <Box fontWeight='fontWeightMedium' display='inline'>
                            {' ' + discoveryItem.verbatim + ' '}
                        </Box>
                        {discoveryItem.after_verbatim}"
                    </Typography></TableCell>
                <TableCell> {discoveryItem.reason || ''}</TableCell>
                <TableCell> {discoveryItem['source_filename']} </TableCell>
                <TableCell> {discoveryItem.page || ''}</TableCell>
            </TableRow>));
    return (
        <div>
            <div style={{ display: "flex" }}>
                <CopyToClipboardButton nodeRef={tableRef} setSnackBarMessage={setSnackBarMessage}></CopyToClipboardButton>
            </div>
            <Table ref={tableRef} sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell style={{ minWidth: "150px" }}>Evidence</TableCell>
                        <TableCell>Notes</TableCell>
                        <TableCell>Document Name</TableCell>
                        <TableCell style={{ minWidth: "150px" }}>Page</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {tableBodyRows}
                </TableBody>
            </Table>
        </div>
    );

    function isValidDiscoveryItem(discoveryItem) {
        return discoveryItem['verbatim'];
    }

}
